import sampleZm089 from "#audio/kokoro-zm-089.mp3";
import sampleZf086 from "#audio/kokoro-zf-086.mp3";
import sampleZm081 from "#audio/kokoro-zm-081.mp3";
import sampleZm100 from "#audio/kokoro-zm-100.mp3";
import sampleZf042 from "#audio/kokoro-zf-042.mp3";

/**
 * A recording of each downloadable voice reading the chooser's sample sentence
 * (今天天气很好，我们一起去公园散散步吧。) at its normal pace, synthesized with the full-precision model
 * and the app's own Mandarin front end, so a learner can hear a voice before downloading it. Keyed
 * by voice id (`voice-catalog`).
 */
export const SENTENCE_VOICE_SAMPLES: ReadonlyMap<string, number> = new Map([
  ["kokoro-zm-089", sampleZm089],
  ["kokoro-zf-086", sampleZf086],
  ["kokoro-zm-081", sampleZm081],
  ["kokoro-zm-100", sampleZm100],
  ["kokoro-zf-042", sampleZf042],
]);
